import { useEffect, useRef, useState } from 'react';
import { isMobile as checkIsMobile } from '@/Utils/index.js';

const playIcon = require('@images/icon-play.svg').default;

const Video = ({ src, image }) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMobile, setIsMobile] = useState(checkIsMobile);
    const [started, setStarted] = useState(false);

    useEffect(() => {
        const onResize = () => setIsMobile(checkIsMobile());
        window.addEventListener('resize', onResize);

        return () => window.removeEventListener('resize', onResize);
    }, []);

    useEffect(() => {
        setStarted(false);
    }, [src]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        setIsPlaying(!video.paused);

        const onPlay = () => setIsPlaying(true);
        const onPause = () => setIsPlaying(false);

        video.addEventListener('play', onPlay);
        video.addEventListener('pause', onPause);

        return () => {
            video.removeEventListener('play', onPlay);
            video.removeEventListener('pause', onPause);
        };
    }, [src]);

    const togglePlayback = () => {
        const video = videoRef.current;
        if (!video) return;

        if (!isMobile) {
            if (!started) {
                setStarted(true);
            }

            if (video.paused) {
                video.play().catch(() => {});
            }

            return;
        }

        if (video.paused) {
            video.play().catch(() => {});
        } else {
            video.pause();
        }
    };

    if (!src) return null;

    const poster = image ? `/storage/${image}` : undefined;
    const isOverlayMode = isMobile || !started;
    const showPlayControl = isOverlayMode || (!isMobile && started && !isPlaying);

    return (
        <div className={`video-player ${isMobile ? 'video-player--mobile' : 'video-player--desktop'}`}>
            <video
                ref={videoRef}
                className="video-player__media"
                src={src}
                playsInline
                controls={!isMobile}
                poster={poster}
            />

            {showPlayControl && (
                <button
                    type="button"
                    onClick={togglePlayback}
                    aria-label={isPlaying ? 'Pause video' : 'Play video'}
                    className={
                        isOverlayMode
                            ? 'video-player__overlay'
                            : 'video-player__btn video-player__btn--center'
                    }
                >
                    {!isPlaying && (
                        isOverlayMode ? (
                            <span className="video-player__btn">
                                <img src={playIcon} alt="" />
                            </span>
                        ) : (
                            <img src={playIcon} alt="" />
                        )
                    )}
                </button>
            )}
        </div>
    );
};

export default Video;
